import {
  WHEEL_SUPPLY_ALL,
  WHEEL_SUPPLY_GET,
  WHEEL_SUPPLY_POST,
  WHEEL_SUPPLY_PUT,
  WHEEL_SUPPLY_DELETE,
  WHEEL_SUPPLY_LOADING,
  WHEEL_SUPPLY_ERROR,
} from '../../actions/types';

const initialState = {
  wheelSupply: null,
  isLoading: true,
  isCompleted: false,
};
// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case WHEEL_SUPPLY_LOADING:
      return { isLoading: true, isCompleted: false };
    case WHEEL_SUPPLY_ERROR:
      return { isLoading: false, isCompleted: false };
    case WHEEL_SUPPLY_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case WHEEL_SUPPLY_GET:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case WHEEL_SUPPLY_POST:
      return { isLoading: false, isCompleted: true };
    case WHEEL_SUPPLY_PUT:
      return { isLoading: false, isCompleted: true };
    case WHEEL_SUPPLY_DELETE:
      return { isLoading: false, isCompleted: true };
    default:
      return state;
  }
}
